<app-splash-screen-ads></app-splash-screen-ads>

<app-header [showDownload]="true" [showNoti]="true" [showRefresh]="true" (refreshEvent)="refreshPage()" (notificationEvent)="notificationPage()"></app-header>

<div id="home">
  <div class="container-fluid">

    <app-account-login  *ngIf="isLoginChecked" parentLink="/home"  [isUserLoggedIn]="isUserLoggedIn"></app-account-login>

    <div class="row slider-parent" style="margin: 0px -15px !important; padding: 0px !important;"> 
      <div class="col-12 px-0">
        <app-banner-ads [gameProviderId]="0"></app-banner-ads>
      </div>
    </div>
  
    <div class="tab mt-2">
      <button class="tablinks active" data-id="all" (click)="openTab('all')">{{ 'all' | translate }}</button>
      <button class="tablinks" data-id="lottery" (click)="openTab('lottery')">{{ 'lottery' | translate }}</button>
      <button class="tablinks" data-id="game" (click)="openTab('game')">{{ 'game' | translate }}</button>
    </div>

    <div id="all" class="tabcontent mt-2" style="display: block;">
      <div class="row mt-2">
        <div class="col-6">
          <a (click)="twodPage()" class="home-item">
            <img src="assets/img/home/2d2.png" alt="">
          </a>
        </div>
        <div class="col-6">
          <a (click)="threedPage()" class="home-item">
            <img src="assets/img/home/3d.png" alt="" class="">
          </a>
        </div>
        <div class="col-6" *ngFor="let gameProviderObj of gameProviderList">
          <a 
            *ngIf="!gameProviderObj.isMaintenance"
            (click)="goToGame(gameProviderObj.provider_id, gameProviderObj.g_type)" 
            class="home-item mt-1"
          >
            <img [src]="gameProviderObj.imageUrl" alt="TwoDBetImage">
          </a>
          <a 
            *ngIf="gameProviderObj.isMaintenance"
            (click)="goToGame(gameProviderObj.provider_id, gameProviderObj.g_type)" 
            class="home-item mt-1"
          >
            <img [src]="gameProviderObj.mimageUrl" alt="TwoDBetImage">
          </a>  
        </div>
      </div>
    </div>

    <div id="lottery" class="tabcontent">
      <div class="row mt-2">
        <div class="col-6">
          <a (click)="twodPage()" class="home-item">
            <img src="assets/img/home/2d2.png" alt="">
          </a>
        </div>
        <div class="col-6">
          <a (click)="threedPage()" class="home-item">
            <img src="assets/img/home/3d.png" alt="">
          </a>
        </div>
      </div>
    </div>

    <div id="game" class="tabcontent">
      <div class="row mt-2">
        <div class="col-6" *ngFor="let gameProviderObj of gameProviderList">
          <a 
            *ngIf="!gameProviderObj.startTime"
            (click)="goToGame(gameProviderObj.provider_id, gameProviderObj.g_type)" 
            class="home-item mt-1"
          >
            <img [src]="gameProviderObj.imageUrl" alt="TwoDBetImage">
          </a>
          <a 
            *ngIf="gameProviderObj.startTime"
            (click)="goToGame(gameProviderObj.provider_id, gameProviderObj.g_type)" 
            class="home-item mt-1"
          >
            <img [src]="gameProviderObj.mimageUrl" alt="TwoDBetImage">
          </a>    
        </div>
      </div>
    </div>

  </div>
</div> <!-- end of home -->

<!-- api loading -->
<ngx-spinner [name]="common.loading.apiLoading.name" [size]="common.loading.apiLoading.size"
  [color]="common.loading.apiLoading.color" [type]="common.loading.apiLoading.type"
  [fullScreen]="common.loading.apiLoading.fullScreen"></ngx-spinner>

<!-- refresh loading -->
<ngx-spinner [name]="common.loading.refreshLoading.name" [size]="common.loading.refreshLoading.size"
  [color]="common.loading.refreshLoading.color" [type]="common.loading.refreshLoading.type"
  [fullScreen]="common.loading.refreshLoading.fullScreen"></ngx-spinner>

<app-navigation-bar *ngIf="isLoginChecked" [isUserLoggedIn]="isUserLoggedIn"></app-navigation-bar>